/* dynamic-layout-sections.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./dynamic-layout-sections.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@compiled/react';
import GenerativeIndicatorIcon from '@atlaskit/icon-lab/core/generative-indicator';
import { Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { isHeaderElement } from '../../dynamic-layout-parser/types/dynamic-layout-section';
import { DynamicLayoutFoldableSection } from './dynamic-layout-foldable-section';
import { OneColumnLayout } from './section-layout/one-column-layout';
import { TwoColumnLayout } from './section-layout/two-column-layout';
import { TwoRowLayout } from './section-layout/two-row-layout';
var styles = {
  overviewStyle: "_2rko12b0 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _bfhki8nm"
};
export var DynamicLayoutSections = function DynamicLayoutSections(_ref) {
  var _section$attributes, _section$attributes2, _section$attributes3, _header$attributes;
  var section = _ref.section;
  var layout = ((_section$attributes = section.attributes) === null || _section$attributes === void 0 ? void 0 : _section$attributes.layout) || 'one-column';
  var isOverview = ((_section$attributes2 = section.attributes) === null || _section$attributes2 === void 0 ? void 0 : _section$attributes2.overview) === '1';
  var isFoldable = (_section$attributes3 = section.attributes) === null || _section$attributes3 === void 0 ? void 0 : _section$attributes3.hasOwnProperty('folded');
  var header;
  var content;
  if (Array.isArray(section.children)) {
    var _section$children;
    var headerElement = section.children.filter(function (element) {
      return isHeaderElement(element);
    });
    if (headerElement.length) {
      header = headerElement[0];
    }
    content = (_section$children = section.children) === null || _section$children === void 0 ? void 0 : _section$children.filter(function (element) {
      return !isHeaderElement(element);
    });
  }
  if (!content) {
    return null;
  }
  var renderContent = function renderContent() {
    var _section$attributes4, _section$attributes5;
    switch (layout) {
      case 'one-column':
        return /*#__PURE__*/React.createElement(OneColumnLayout, {
          elements: content
        });
      case 'two-columns':
        return /*#__PURE__*/React.createElement(TwoColumnLayout, {
          elements: content,
          key: (_section$attributes4 = section.attributes) === null || _section$attributes4 === void 0 ? void 0 : _section$attributes4.n
        });
      case 'two-rows':
        return /*#__PURE__*/React.createElement(TwoRowLayout, {
          elements: content,
          key: (_section$attributes5 = section.attributes) === null || _section$attributes5 === void 0 ? void 0 : _section$attributes5.n
        });
    }
  };
  if (isFoldable) {
    return /*#__PURE__*/React.createElement(DynamicLayoutFoldableSection, {
      section: section,
      header: header,
      content: content
    }, renderContent());
  }
  return /*#__PURE__*/React.createElement(Stack, {
    space: "space.100",
    alignInline: "start",
    xcss: cx(isOverview && styles.overviewStyle)
  }, header && ((_header$attributes = header.attributes) === null || _header$attributes === void 0 ? void 0 : _header$attributes.show) !== 'false' && content && /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    alignBlock: "center"
  }, isOverview && /*#__PURE__*/React.createElement(GenerativeIndicatorIcon, {
    label: "AI Content",
    size: "medium"
  }), /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, header && header.children)), renderContent());
};